import React from "react";
import { getProgramPreviewPath } from "./blockHelpers";

const ToggleComponent = ({
  handleToggle,
  tabIndex,
  dotsToggler,
  editCycle,
  fromAthlete,
  athlete,
  program,
}) => {
  if (dotsToggler) {
    return (
      <div className="toggle-container">
        <div
          onClick={() => handleToggle(0)}
          className={
            tabIndex === 0 ? "dot-toggle active-dot" : "dot-toggle inactive-dot"
          }
        />
        <div
          onClick={() => handleToggle(1)}
          className={
            tabIndex === 1 ? "dot-toggle active-dot" : "dot-toggle inactive-dot"
          }
        />
      </div>
    );
  }

  const notSingleWorkout = editCycle.storeType !== "single-workout";

  return (
    <nav role="tablist">
      <a
        onClick={() => handleToggle(0)}
        aria-current={tabIndex === 0 ? true : undefined}
      >
        Overview
      </a>

      <a
        onClick={() => handleToggle(1)}
        aria-current={tabIndex === 1 ? true : undefined}
      >
        {notSingleWorkout ? "Blocks/exercises" : "Execises"}
      </a>
      <div className="action-buttons">
        {!notSingleWorkout && editCycle.video && (
          <a
            role="button"
            data-button-type="primary"
            href={editCycle.video}
            target="_blank"
          >
            Open Video
          </a>
        )}

        <a
          role="button"
          data-button-type="secondary"
          href={getProgramPreviewPath(editCycle._id, fromAthlete, athlete)}
        >
          Preview Program
        </a>
        {fromAthlete && (
          <a
            role="button"
            data-button-type="secondary"
            href={`/actions/refresh?modal[type]=add-to-calendar&cycleId=${program._id}&wholeCycle=true`}
          >
            Add To Calendar
          </a>
        )}
      </div>
    </nav>
  );
};

export default ToggleComponent;
